import Storage from "@/utils/storage";
import LocationService from "@/services/LocationService";
import CommonService from "@/services/CommonService";
const Location = {
  namespaced: true,
  state: () => ({
    countryList: Storage.get("countryList" + CommonService.currentLanguage(), '[]'),
    languages: Storage.get("languages", "[]"), // current
    country: Storage.get("country", "{}"), // current
    region: Storage.get("region"), // current
    city: Storage.get("city"), // current
    countryLang: Storage.get("countryLang", "[]"),
  }),
  //mutations are synchronous transactions
  mutations: {
    SET_COUNTRY_LANG(state, data) {
      state.countryLang = data;
      Storage.set("countryLang", JSON.stringify(data));
    },
    SET_COUNTRY_LIST(state, data) {
      state.countryList = data;
      Storage.set("countryList", JSON.stringify(data));
    },
    SET_CURRENT_LOCATION(state, {country, region, city, languages}) {

      state.languages = languages || [];
      Storage.set("languages", JSON.stringify(state.languages));

      state.country = country || "";
      Storage.set("country", JSON.stringify(state.country));

      state.region = region || "";
      Storage.set("region", state.region);

      state.city = city || "";
      Storage.set("city", state.city);
    },
  },
  //make mutations synchronous
  actions: {
    async setCountryList({ commit, state }) {
      // if state not setup
      if (!state.countryList.length) {
        const country = await LocationService.getCurrentLocation();
        state.countryList = country
        Storage.set('countryList' + CommonService.currentLanguage(), JSON.stringify(country))
      }
      if (!Array.isArray(state.countryLang) || !state.countryLang.length) {
        const lang = await LocationService.getLangLocation();
        commit("SET_COUNTRY_LANG", lang);
      }
    },
    async getStateLocation({}, key) {
      return await LocationService.getStateLocation(key);
    },
    async getCityLocation({}, key) {
      return await LocationService.getCityLocation(key);
    },
  },
};

export default Location;
